import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './CSS/Profile_model.css';
import SemResult from './SemResult';

const Profile = () => {
    const [student, setStudent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showSemesterResult, setshowSemesterResult] = useState(true);
    const [enableSemesterResult, setEnableSemesterResult] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const [showNavBar, setShowNavBar] = useState(true);
    const [showConfirmationPrompt, setShowConfirmationPrompt] = useState(false);
    const overlayClass = `loading-overlay${loading || isLoading ? ' visible' : ''}`;
    const loggedInEmail = localStorage.getItem('loggedInEmail');
    const navigate = useNavigate();

    useEffect(() => {
        // Detect device type and set the state
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        isMobile ? setShowNavBar(false) : setShowNavBar(true)
    }, [showSemesterResult]);

    useEffect(() => {
        const fetchStudentData = async () => {
            try {
                const response = await axios.get('https://result-api-kiot.vercel.app/api/fetch_student_data', {
                    params: {
                        registerNumber: loggedInEmail // Filter by institute_name
                    }
                });
                const studentData = response.data;
                setStudent(studentData);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching student data:', error);
                setLoading(false);
            }
        };

        fetchStudentData();
    }, [loggedInEmail]);

    const handleTestScoreClose = () => {
        setshowSemesterResult(true);
        document.querySelectorAll('.profile-attendance-chart,.chart-container1,.chart-details-container1 ,.attendance-chart, .overall-performance-chart, .analytics-container, .message-container').forEach((element) => {
            element.style.display = 'flex';
        });
    };

    const handleShowSemesterResults = () => {
        setshowSemesterResult(true);
        setIsLoading(true);
        // Add loading class to content-container to blur the background
        // Hide the chart elements
        document.querySelectorAll('.profile-attendance-chart,.chart-container1,.profile-chart-container,.chart-details-container1, .attendance-chart, .overall-performance-chart,.analytics-container, .message-container').forEach((element) => {
            element.style.display = 'none';
        });
        // Create a new message element and append it to the content-container
        const messageElement = document.createElement('div');
        messageElement.style.color = 'white'; // Set the color to white
        document.querySelector('.profile-content-container').appendChild(messageElement);
        // After a short delay, remove the loading class and the message element to show the loading overlay
        setTimeout(() => {
            setIsLoading(false);
            messageElement.remove();
            setshowSemesterResult(true);
        }, 1000); // Adjust the duration (in milliseconds) to control the transition time
    };


    const handleLogout = () => {
        setShowConfirmationPrompt(false);
        localStorage.removeItem('loggedInEmail');
        navigate('/');
    };

    const handleShowNav = () => {
        setShowNavBar((prevShowNavBar) => !prevShowNavBar);
    };

    if (!student) {
        return <p>loading...</p>;
    }

    const logoImageUrl = `./uploads/dashboard-brand-logo.JPG`;

    function getInstituteFullName(instituteName) {
        const instituteNameMap = {
            "KIOT": "KNOWLEDGE INSTITUTE OF TECHNOLOGY",
            "MHS": "MUNICIPAL HIGHER SECONDARY SCHOOL",
            "PSG": "PSG COIMBATORE",
        };
        return instituteNameMap[instituteName] || instituteName;
    }




    return (
        <div className="page-container">
            {showNavBar &&
                <nav className="navigation1">
                    <ul>
                        <li>
                            <div className="student-details-card">
                                <div className="image-container">
                                    <img src={logoImageUrl} alt="brand Logo" />
                                </div>
                                {/*
                                <div className="image-container">
                                    <img src={imageUrl} alt="Profile Picture" />
                                </div>
                                */}
                                <p className="student-details">
                                    {student.studentName}
                                    <br />
                                    {student.degreeAndBranch}
                                    <br />
                                    <br />
                                </p>
                            </div>
                        </li>
                        {enableSemesterResult &&
                            <li>
                                <div>
                                    <a href="#" className="test-score-button" id='semester-score-button' onClick={handleShowSemesterResults}>Semester Results</a>
                                </div>
                            </li>
                        }
                    </ul>
                </nav>}
            <div
                className={`profile-right-content-container ${showNavBar ? "with-nav-bar" : "without-nav-bar"
                    }`}>
                <header
                    className="admin-header">
                    <div className='nav-bar-hider'>
                        <img src="./uploads/nav-menu.png" href="#" onClick={handleShowNav} id='nav-menu-button' alt="Dashboard-icon Icon"
                            className={`nav-button-menu ${showNavBar ? "with-nav-bar" : "without-nav-bar"
                                }`} />
                    </div>
                    <div className='header-dialogue'>
                        <p>{getInstituteFullName(student.institute_name)}</p>
                    </div>
                    <div >
                        <button className='logout-button' onClick={() => setShowConfirmationPrompt(true)}>
                            Logout
                        </button>
                    </div>
                    {showConfirmationPrompt && (
                        <div className="logout-overlay">
                            <div className="confirmation-container">
                                <p>Are you sure you want to logout?</p>
                                <button className="confirm-button" onClick={handleLogout}>Yes</button>
                                <button className="cancel-button" onClick={() => setShowConfirmationPrompt(false)}>No</button>
                            </div>
                        </div>
                    )}
                </header>
                <main
                    className={`profile-content-container ${showNavBar ? "with-nav-bar" : "without-nav-bar"
                        }`}>
                    <div>
                        {(isLoading || loading) && <div className={overlayClass}>
                            <div className="spinner">
                                <img src="./uploads/loading-brand-logo.png" alt="loading-brand-logo" id="loading-brand-logo" />
                            </div>
                            <img src="./uploads/loading-brand-title.png" alt="loading-brand-title" id="loading-brand-title" />
                        </div>}
                    </div>
                    {showSemesterResult &&
                        <div className='attendance-page-container'>
                            <SemResult student={student} onClose={handleTestScoreClose} />
                        </div>
                    }
                </main>
            </div>
        </div>
    );
};

export default Profile;